import { render } from "./users.widget.wp.vue?vue&type=template&id=b8def854"
import script from "./users.widget.wp.vue?vue&type=script&lang=js"
export * from "./users.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__